module.exports = __webpack_public_path__ + "img/user-info.89de5557.svg";